import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { PageTitleComponent } from '@base/components/page-title/page-title.component';
import { UserListComponent } from '../../components/user-list/user-list.component';
import { UserAddComponent } from '../../components/user-add/user-add.component';
import { UserBasePageComponent } from '../user-base-page/user-base-page.component';
import { AdminApiService } from '../../services/admin-api.service';
import { Observable } from 'rxjs';
import { UserModel } from '@base/models/user.model';

@Component({
  selector: 'app-non-makler-page',
  standalone: true,
  imports: [
    AsyncPipe,
    PageTitleComponent,
    UserAddComponent,
    UserListComponent,
    UserListComponent,
    UserAddComponent
  ],
  templateUrl: './non-makler-page.component.html',
  styleUrl: './non-makler-page.component.scss',
  providers: [AdminApiService]
})
export class NonMaklerPageComponent extends UserBasePageComponent {

  override users$: Observable<UserModel[]> = this.adminApiService.getAllNonMaklers();
}
